import { hot } from 'react-hot-loader/root';
import { BrowserRouter } from 'react-router-dom';

import App from './shared/pages/App';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { ErrorPage } from '@zg-rentals/error-page-components';
import { getErrorPageAction, getErrorPageTextProps } from './shared/utils/getErrorPageTextProps';

const LeasingApp = () => (
  <RpErrorBoundary
    fallback={
      <ErrorPage
        errorMessage="Coud not load your lease"
        errorDetails="You may not have access to this lease, try again later."
        action={getErrorPageAction()}
      />
    }
    {...getErrorPageTextProps()}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </RpErrorBoundary>
);

export default hot(LeasingApp);
